import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import HandicaddieLogo from "../../../icons/HandicaddieLogo";

interface Props {
}

export const NoCaddieMasters = ({}: Props) => {

    return <>
        <Container
            className={"contentContainer"}
            style={{
                height: "calc(100vh - 76px)",
                marginTop: "0px",
            }}
            fluid={true}
        >
            <div
                style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div
                    style={{
                        minWidth: "50%",
                        width: "auto",
                        height: "auto",
                        padding: "10px",
                        borderRadius: "10px",
                    }}
                >
                    <Row>
                        <HandicaddieLogo size={'lg'} />
                    </Row>
                    <Col style={{display: 'flex', padding: '5em', justifyContent: 'center', textAlign: 'center'}}>
                        <p>You need to wait for your account to be approved to see caddie reviews.
                            <br />
                            If you think you should be approved, please reach out to <code>help@handicaddie.com</code>.</p>
                    </Col>
                </div>
            </div>
        </Container>
    </>
}